<template>
    <section class="section">
        <div class="container">
            <div class="row">
                <a class="target" aria-hidden="true" name="target" id="about-us">&nbsp;</a>
                <h2 class="section-heading col-12 col-md-3">About us</h2>
                <div class="col-12 col-md-9" v-html="aboutText">
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "About",
    computed: {
        aboutText() {
            return this.$store.state.about
        }
    }
}
</script>